import React, { useState, useEffect } from 'react';
import './Loader.css';

const Loader = () => {
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading progress
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => setIsLoading(false), 500);
          return 100;
        }
        return prev + Math.random() * 15;
      });
    }, 150);

    return () => clearInterval(interval);
  }, []);

  if (!isLoading) return null;

  return (
    <div className="loader-wrapper">
      <div className="loader-content">
        {/* Logo/Name */}
        <div className="loader-logo">
          <h1 className="loader-name">
            <span className="name-first">Sadiq</span>
            <span className="name-last">Haruna</span>
          </h1>
          <p className="loader-title">Senior Full-Stack Engineer</p>
        </div>

        {/* Loading Text */}
        <div className="loader-text">
          <span className="loading-dots">Loading Portfolio</span>
        </div>

        {/* Progress Bar */}
        <div className="progress-container">
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${Math.min(progress, 100)}%` }}
            >
              <div className="progress-glow"></div>
            </div>
          </div>
          <div className="progress-percentage">
            {Math.floor(Math.min(progress, 100))}%
          </div>
        </div>

        {/* Animated Particles */}
        <div className="loader-particles">
          {[...Array(20)].map((_, i) => (
            <div 
              key={i} 
              className="particle" 
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${3 + Math.random() * 2}s`
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Loader;
